import { useMsal } from "@azure/msal-react";
import { IContextualMenuItem, Link, Spinner, Stack } from "@fluentui/react";
import { RootState } from "app/store";
import CustomPanel from "components/controls/CustomPanel";
import { EValidationSeverity, IValidationMessage } from "components/controls/ValidationView/ValidationView.type";
import { useAuthentication } from "global/Authentication";
import { AppDataSource } from "global/DataSources/AppDataSource";
import { MsalTokenSource } from "global/DataSources/MsalTokenSource";
import { useEffect, useState } from "react";
import { connect, ConnectedProps, useDispatch } from "react-redux";
import ValidationItem from "views/BlueRelationship/ValidationDialog/ValidationItem";

import { bcbs_grouplibraryprocess } from "model/AttributeOptionSets.type";
import { Ibcbs_grouplibraryprocess_extended } from "model/CRM.type";
import { OnRenderDescriptionValidationItem } from "views/BlueRelationship/ValidationDialog/RenderValidationDescription";
import LinkTo from "components/controls/LinkTo";
import { formatDate } from "global/Utility/TSFunctions";
import Formatters from "global/Utility/Formatters";

interface IProps extends TComponentConnectedProps {
}


const ProcessPanel: React.FunctionComponent<IProps> = (props) => {
    const [refresh, SetRefresh] = useState(0);

    const { instance } = useMsal();
    const tokenSource = new MsalTokenSource(instance);
    const dataSource = new AppDataSource(tokenSource);

    const [items, setItems] = useState<IValidationMessage[] | null>(null)

    const authentication = useAuthentication();

    const [loading, setLoading] = useState(false);

    const mapping: Record<string, string> = {
        bcbs_sqlrecordgenerationurl: 'SQL Record Generation',
        bcbs_adobecampaignextract: 'Adobe Campaign Extract',
        bcbs_autogeneratebdr: 'Benefit Detail Report',
        bcbs_autogeneratebenefitdetailextract: 'Benefit Detail Extract',
        bcbs_gsrecordgenerationurl: ' Gold Standard Generation',
        bcbs_submitsbc: 'SBC Submission',
        bcbs_emchecklistnotify: 'E&M CheckList Notification',
    }

    const dispatch = useDispatch();


    const menu: IContextualMenuItem[] = [];
    menu.push({
        key: 'refresh',
        name: 'Refresh',
        icon: 'Refresh',
        onClick: (event, item) => {
            event?.preventDefault();
            event?.stopPropagation();
            SetRefresh(t => t + 1);
        },
    });

    function processStateMapping(bcbs_processstate: number | undefined): EValidationSeverity {
        switch (bcbs_processstate) {
            case bcbs_grouplibraryprocess.bcbs_processstate["Failed(808900003)"].value:
                return EValidationSeverity.error;

            case bcbs_grouplibraryprocess.bcbs_processstate["In Progress(808900001)"].value:
                return EValidationSeverity.info;

            case bcbs_grouplibraryprocess.bcbs_processstate["Completed(808900002)"].value:
                return EValidationSeverity.success;

            default:
                return EValidationSeverity.warn;
        }
    }

    function retry(process: Ibcbs_grouplibraryprocess_extended) {
        (async () => {

            try {

                const changes = {
                    bcbs_retriesremaining: 10,
                    bcbs_processstate: 808900000,
                    bcbs_grouplibraryprocessid: process.bcbs_grouplibraryprocessid
                };

                await dataSource.updateGroupLibraryProcess(process.bcbs_grouplibraryprocessid!, changes);

                SetRefresh(t => t + 1);
            } catch (error) {
                throw error;
                // debug code, ignore handler for now
            } finally {

            }

        })();

    }

    useEffect(() => {
        (async () => {

            setLoading(true);

            try {

                const result = await dataSource.getGroupLibraryProcessByRecordId(props.state.data.snapshot.bcbs_groupconfigurationsnapshotid!);
                result.value.sort((a, b) => {
                    return new Date(a.createdon!).getTime() - new Date(b.createdon!).getTime();
                });

                if (result.value.length > 0) {
                    const items = result.value.map(eachProcess => {
                        const t: IValidationMessage = {
                            title: `${Formatters.ToShortDateTime(eachProcess.createdon!)} - ${mapping[eachProcess.bcbs_triggerreason ?? ''] ?? eachProcess.bcbs_triggerreason} - ${eachProcess["bcbs_processstate@OData.Community.Display.V1.FormattedValue"]}.`,
                            type: processStateMapping(eachProcess.bcbs_processstate),
                            onRenderDescription: OnRenderDescriptionValidationItem(
                                <div>
                                    <table>
                                        <tr>
                                            <td style={{ textAlign: 'right' }}>Process:</td>
                                            <td><LinkTo process={eachProcess} /></td>
                                        </tr>
                                        <tr>
                                            <td style={{ textAlign: 'right' }}>Retries Remaining:</td>
                                            <td>{eachProcess.bcbs_retriesremaining}</td>
                                        </tr>
                                        <tr>
                                            <td style={{ textAlign: 'right' }}>Trigger Reason:</td>
                                            <td>{mapping[eachProcess.bcbs_triggerreason ?? ''] ?? eachProcess.bcbs_triggerreason}</td>
                                        </tr>
                                        <tr>
                                            <td style={{ textAlign: 'right' }}>Created On:</td>
                                            <td>{Formatters.ToShortDateTime(eachProcess.createdon!)}</td>
                                        </tr>
                                        <tr>
                                            <td style={{ textAlign: 'right' }}>Modified On:</td>
                                            <td>{Formatters.ToShortDateTime(eachProcess.modifiedon!)}</td>
                                        </tr>
                                        <tr>
                                            <td style={{ textAlign: 'right' }}></td>
                                            <td> <Link onClick={() => retry(eachProcess)}>retry</Link></td>
                                        </tr>
                                    </table>
                                </div>
                            )
                        };

                        return t;
                    });

                    setItems(items);
                }

            } catch (error) {

            } finally {
                setLoading(false);
            }


        })();

    }, [refresh]);

    return <CustomPanel title={"Processes"}
        canCollapse={true}
        items={menu}
    >
        {loading &&
            <div>
                <Spinner styles={{ root: { margin: '25px' } }} />
            </div>
        }
        <Stack styles={{ root: { marginTop: '10px' } }}>
            {items && items.map((item, ix) => {
                return <ValidationItem
                    key={ix}
                    data={item}
                />
            })}

        </Stack>
    </CustomPanel>;
}

function mapStateToProps(state: RootState) { return { state } }
const connector = connect(mapStateToProps);
type TComponentConnectedProps = ConnectedProps<typeof connector>;
export default connector(ProcessPanel)

